import React, { useEffect } from 'react';

import { useTranslation } from '@tecma/i18n';
import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'store';
import { authActions } from 'store/sagas/application/auth/auth.actions';
import { applicationStateSelectors } from 'store/slices/applicationState/selectors';
import { environmentSelectors } from 'store/slices/environment/selector';
import { ProjectInfo } from 'types/project';

import { Footer } from 'components/Footer';
import { Header } from 'components/Header';

import { LOCALE_PARAM_KEY } from '../../constants';
import './layout.scss';

interface LayoutProps {
  children?: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();
  const projectInfo = useSelector(applicationStateSelectors.selectProjectInfo) as ProjectInfo;
  const environment = useSelector(environmentSelectors.environment);
  const urlParams = new URLSearchParams(window.location.search);
  const localeParam = urlParams.get(LOCALE_PARAM_KEY);
  const { user, token } = useSelector((state: RootState) => state.auth);
  const BUCKET_PROJECT_PATH = `${environment.REACT_APP_BUCKET_BASEURL}/initiatives/${encodeURI(projectInfo.displayName)}`;
  let logo = `${BUCKET_PROJECT_PATH}/global/img/logo192.png`;

  if (projectInfo.area === 'sale') {
    logo = `${BUCKET_PROJECT_PATH}/global/img/primary-logo.svg`;
  }

  useEffect(() => {
    if (localeParam) {
      i18n.changeLanguage(localeParam);
    }
  }, [localeParam]);

  useEffect(() => {
    if (token && user) {
      dispatch(authActions.startCountDown({ token, user }));
    }
  }, [token, user]);

  return (
    <div className='layout'>
      <Header languages={projectInfo.languages} logo={logo} />
      {children}
      <Footer />
    </div>
  );
};

export default React.memo(Layout);
